export default "__VITE_ASSET__Dd$2Lh_n__"